/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout/DashboardLayout";
import style from "./index.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import Dialog from "../../../components/Dialog";
import { ScaleLoader } from "react-spinners";
import { Pagination } from "../../../components/Pagination";

export const Card = ({ phonebookInfo }) => {
  const cards = [
    {
      description: "Number of Phonebook",
      num: `${phonebookInfo ? phonebookInfo.totalPhonebooks : "0"}`,
    },
    {
      description: "Total Number of Contacts",
      num: `${phonebookInfo ? phonebookInfo.totalContacts : "0"}`,
    },
  ];
  return (
    <div>
      <ul className={style["cards--container"]}>
        {cards.map((item, index) => (
          <li className={style["cards--item"]}>
            <header>
              <div className={style["metrics"]}>
                <h2>{item.num}</h2>
                <span className={style["icon"]}>
                  {index === 0 ? (
                    <svg
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="#750005"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#750005" }}
                        d="M15.9434 15.9375H14.8809V11.6875H15.9434C16.2422 11.6875 16.494 11.7899 16.6987 11.9946C16.9035 12.1994 17.0058 12.4512 17.0058 12.75V14.875C17.0058 15.1738 16.9035 15.4256 16.6987 15.6304C16.494 15.8351 16.2422 15.9375 15.9434 15.9375ZM15.9434 10.625H14.8809V6.375H15.9434C16.2422 6.375 16.494 6.47738 16.6987 6.68213C16.9035 6.88688 17.0058 7.13867 17.0058 7.4375V9.5625C17.0058 9.86133 16.9035 10.1131 16.6987 10.3179C16.494 10.5226 16.2422 10.625 15.9434 10.625ZM15.9434 5.3125H14.8809V1.0625H15.9434C16.2422 1.0625 16.494 1.16488 16.6987 1.36963C16.9035 1.57438 17.0058 1.82617 17.0058 2.125V4.25C17.0058 4.54883 16.9035 4.80062 16.6987 5.00537C16.494 5.21012 16.2422 5.3125 15.9434 5.3125ZM13.8184 15.9375C13.8184 16.2253 13.716 16.4743 13.5112 16.6846C13.3065 16.8949 13.0547 17 12.7559 17H1.06836C0.780599 17 0.531575 16.8949 0.321289 16.6846C0.111003 16.4743 0.00585938 16.2253 0.00585938 15.9375V1.0625C0.00585938 0.763672 0.111003 0.511882 0.321289 0.307129C0.531575 0.102376 0.780599 0 1.06836 0H12.7559C13.0547 0 13.3065 0.102376 13.5112 0.307129C13.716 0.511882 13.8184 0.763672 13.8184 1.0625V15.9375ZM7.97461 10.1934V9.89453C9.0371 9.46289 9.56835 8.28971 9.56835 6.375C9.56835 5.67773 9.3221 5.14925 8.82959 4.78955C8.33707 4.42985 7.70068 4.25 6.92041 4.25C6.14013 4.25 5.50097 4.42985 5.00293 4.78955C4.50488 5.14925 4.25586 5.67773 4.25586 6.375C4.25586 8.23438 4.78711 9.40202 5.84961 9.87793V10.1934C5.08593 10.3262 4.45508 10.5752 3.95703 10.9404C3.45898 11.3057 3.20443 11.7207 3.19336 12.1855C3.19336 12.3184 3.31234 12.4263 3.55029 12.5093C3.78825 12.5923 4.13688 12.6504 4.59619 12.6836C5.0555 12.7168 5.43457 12.7362 5.7334 12.7417C6.03222 12.7472 6.42513 12.75 6.91211 12.75C7.39908 12.75 7.79199 12.7472 8.09082 12.7417C8.38964 12.7362 8.76871 12.7168 9.22802 12.6836C9.68733 12.6504 10.036 12.5923 10.2739 12.5093C10.5119 12.4263 10.6309 12.3184 10.6309 12.1855C10.6198 11.7207 10.3652 11.3057 9.86718 10.9404C9.36913 10.5752 8.73828 10.3262 7.97461 10.1934Z"
                        fill="#750005"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="24"
                      height="18"
                      viewBox="0 0 24 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{
                          fill: "#750005",
                          padding: "2rem",
                          background: "gree",
                        }}
                        d="M10.5 18C10.5 18 9 18 9 16.5C9 15 10.5 10.5 16.5 10.5C22.5 10.5 24 15 24 16.5C24 18 22.5 18 22.5 18H10.5ZM16.5 9C17.6935 9 18.8381 8.52589 19.682 7.68198C20.5259 6.83807 21 5.69347 21 4.5C21 3.30653 20.5259 2.16193 19.682 1.31802C18.8381 0.474106 17.6935 0 16.5 0C15.3065 0 14.1619 0.474106 13.318 1.31802C12.4741 2.16193 12 3.30653 12 4.5C12 5.69347 12.4741 6.83807 13.318 7.68198C14.1619 8.52589 15.3065 9 16.5 9Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                      <path
                        style={{ fill: "#750005" }}
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.824 17.9999C7.60163 17.5316 7.49073 17.0182 7.5 16.4999C7.5 14.4674 8.52 12.3749 10.404 10.9199C9.46364 10.6302 8.48392 10.4885 7.5 10.4999C1.5 10.4999 0 14.9999 0 16.4999C0 17.9999 1.5 17.9999 1.5 17.9999H7.824Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                      <path
                        style={{ fill: "#750005" }}
                        d="M6.75 9C7.74456 9 8.69839 8.60491 9.40165 7.90165C10.1049 7.19839 10.5 6.24456 10.5 5.25C10.5 4.25544 10.1049 3.30161 9.40165 2.59835C8.69839 1.89509 7.74456 1.5 6.75 1.5C5.75544 1.5 4.80161 1.89509 4.09835 2.59835C3.39509 3.30161 3 4.25544 3 5.25C3 6.24456 3.39509 7.19839 4.09835 7.90165C4.80161 8.60491 5.75544 9 6.75 9Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                    </svg>
                  )}
                </span>
              </div>
              <p>{item.description}</p>
            </header>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ActionCard = ({ handleDelete, handleView, handleEdit }) => {
  return (
    <div className={style["action--dialog"]}>
      <div>
        <p className={style["view--action"]} onClick={handleView}>
          <span style={{ marginRight: "1rem" }}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.5 13.5H13.5V15H7.5V13.5Z" fill="#219681" />
              <path d="M7.5 13.5H13.5V15H7.5V13.5Z" fill="#219681" />
              <path d="M7.5 9.75H16.5V11.25H7.5V9.75Z" fill="#219681" />
              <path d="M7.5 9.75H16.5V11.25H7.5V9.75Z" fill="#219681" />
              <path d="M7.5 17.25H11.25V18.75H7.5V17.25Z" fill="#219681" />
              <path d="M7.5 17.25H11.25V18.75H7.5V17.25Z" fill="#219681" />
              <path
                style={{ fill: "#219681" }}
                d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
                fill="#219681"
              />
              <path
                style={{ fill: "#219681" }}
                d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
                fill="#219681"
              />
            </svg>
          </span>
          <span> View details</span>
        </p>
      </div>
      <hr className={style["divider"]} />
      <div>
        <p className={style["edit--action"]} onClick={handleEdit}>
          <span style={{ marginRight: "1rem" }}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ fill: "#fff" }}
                d="M11 5.00016H6C5.46957 5.00016 4.96086 5.21088 4.58579 5.58595C4.21071 5.96102 4 6.46973 4 7.00016V18.0002C4 18.5306 4.21071 19.0393 4.58579 19.4144C4.96086 19.7894 5.46957 20.0002 6 20.0002H17C17.5304 20.0002 18.0391 19.7894 18.4142 19.4144C18.7893 19.0393 19 18.5306 19 18.0002V13.0002M17.586 3.58616C17.7705 3.39514 17.9912 3.24278 18.2352 3.13796C18.4792 3.03314 18.7416 2.97797 19.0072 2.97566C19.2728 2.97335 19.5361 3.02396 19.7819 3.12452C20.0277 3.22508 20.251 3.37359 20.4388 3.56137C20.6266 3.74916 20.7751 3.97246 20.8756 4.21825C20.9762 4.46405 21.0268 4.72741 21.0245 4.99296C21.0222 5.25852 20.967 5.52096 20.8622 5.76497C20.7574 6.00898 20.605 6.22967 20.414 6.41416L11.828 15.0002H9V12.1722L17.586 3.58616Z"
                stroke="#1565D8"
                stroke-opacity="0.7"
                stroke-width="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span> Edit</span>
        </p>
      </div>
      <hr className={style["second-divider"]} />
      <div>
        <p className={style["delete--action"]} onClick={handleDelete}>
          <span style={{ marginRight: "1rem" }}>
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ fill: "#fff" }}
                d="M7 9V15M11 9V15M1 5H17M16 5L15.133 17.142C15.0971 17.6466 14.8713 18.1188 14.5011 18.4636C14.1309 18.8083 13.6439 19 13.138 19H4.862C4.35614 19 3.86907 18.8083 3.49889 18.4636C3.1287 18.1188 2.90292 17.6466 2.867 17.142L2 5H16ZM12 5V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H7C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V5H12Z"
                stroke="#EB2931"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span> Delete</span>
        </p>
      </div>
    </div>
  );
};

const Phonebook = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [notFound, setNotFound] = React.useState(null);
  const [phonebooks, setPhonebooks] = React.useState(null);
  const userInfo = useSelector((state) => state.auth.authState);
  const [selectedPhonebook, setSelectedPhonebook] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);

  const toggling = (index) => {
    setIsOpen(!isOpen);
    setSelectedPhonebook(index);
  };

  const handleCreatePhonebook = () => {
    navigate("/user/phonebook/create");
  };

  const handleViewPhonebook = (id, name) => {
    navigate(`/user/phonebooks/${id}/${name}`);
  };

  const handleEditPhonebook = (id, name, total) => {
    navigate(`/user/phonebook/edit/${id}/${name}/${total}`);
  };
  const th = [
    {
      name: "S/N",
    },
    {
      name: "Name of Phonebook",
    },
    {
      name: "No Of Contacts",
    },
    {
      name: "",
    },
  ];

  const fetchAllPhonebook = async () => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/phonebook/dev/client/summary`,
        {
          client_id: userInfo.id,
          token: userInfo.token,
        }
      );
      if (res.status === 200) {
        setPhonebooks(res.data);
      } else {
        setPhonebooks(res.data);
      }
    } catch (error) {
      setNotFound("No phonebook created yet");
    }
  };

  useEffect(() => {
    const getAllPhonebook = async () => {
      setIsLoadingTable(true);
      try {
        let res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/phonebook/dev/client/summary`,
          {
            client_id: userInfo.id,
            token: userInfo.token,
          }
        );
        if (res.status === 200) {
          setPhonebooks(res.data);
        } else {
          setPhonebooks(res.data);
        }
        setIsLoadingTable(false);
      } catch (error) {
        setNotFound("No phonebook created yet");
      }
    };
    getAllPhonebook();
  }, []);
  const handleDeleteDialog = (id) => {
    setDeleteModalOpen(true);
    setSelectedPhonebook(id);
  };

  const handleDeletePhonebook = async () => {
    setIsLoading(true);
    setDeleteModalOpen(!deleteModalOpen);
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/phonebook/dev/${selectedPhonebook}/delete?token=${userInfo.token}`,
        {
          client_id: userInfo.id,
        }
      );

      if (res.status) {
        fetchAllPhonebook();
      } else {
        console.log(res.data);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout
      pageTitle={location.pathname === "/user/phonebook" ? "Phonebook" : ""}
    >
      <Dialog isOpen={isLoading}>
        <ScaleLoader />
      </Dialog>
      <Dialog
        isOpen={deleteModalOpen}
        toggleModal={() => setDeleteModalOpen(!deleteModalOpen)}
      >
        <div className={style.deleteModal}>
          <p>Are You Sure you want to Delete This Phonebook?</p>
          <div className={style.buttons}>
            <div>
              <Button
                type="submit"
                className="medium--filled"
                onClick={handleDeletePhonebook}
              >
                Yes
              </Button>
            </div>
            <div>
              <Button
                type="submit"
                className="medium--ghost"
                onClick={() => {
                  setIsOpen(!isOpen);
                  setDeleteModalOpen(!deleteModalOpen);
                }}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </Dialog>

      <div style={{ padding: "2rem" }}>
        <Card
          phonebookInfo={
            phonebooks && {
              totalPhonebooks: phonebooks.totalPhonebooks
                ? phonebooks.totalPhonebooks
                : 0,
              totalContacts: phonebooks.totalContacts
                ? phonebooks.totalContacts
                : 0,
            }
          }
        />

        <div className={style["table--top"]}>
          <p>All Phonebook</p>
          <Button
            type="button"
            className="small--filled"
            onClick={handleCreatePhonebook}
            style={{ width: "250px" }}
          >
            <span style={{ paddingRight: ".5rem" }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  style={{ fill: "#fff" }}
                  d="M16 7V10V7ZM16 10V13V10ZM16 10H19H16ZM16 10H13H16ZM11 5C11 6.06087 10.5786 7.07828 9.82843 7.82843C9.07828 8.57857 8.06087 9 7 9C5.93913 9 4.92172 8.57857 4.17157 7.82843C3.42143 7.07828 3 6.06087 3 5C3 3.93913 3.42143 2.92172 4.17157 2.17157C4.92172 1.42143 5.93913 1 7 1C8.06087 1 9.07828 1.42143 9.82843 2.17157C10.5786 2.92172 11 3.93913 11 5V5ZM1 18C1 16.4087 1.63214 14.8826 2.75736 13.7574C3.88258 12.6321 5.4087 12 7 12C8.5913 12 10.1174 12.6321 11.2426 13.7574C12.3679 14.8826 13 16.4087 13 18V19H1V18Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Create Phonebook
          </Button>
        </div>
        <div
          className={style["table--container"]}
          style={{
            background: notFound ? "" : "#ffffff",
            border: notFound ? "" : "1px solid rgba(0, 0, 0, 0.4)",
          }}
        >
          <table id="test">
            <thead>
              <tr>
                {th.map((item, index) => {
                  return <th key={index}>{item.name}</th>;
                })}
              </tr>
            </thead>

            <tbody>
              {notFound ? (
                <tr className={style["empty--table"]}>
                  <span>
                    <svg
                      width="56"
                      height="46"
                      viewBox="0 0 56 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M45.5 45.5L56 17.5H10.5L0 45.5H45.5ZM7 14L0 45.5V0H15.75L22.75 7H45.5V14H7Z"
                        fill="#828282"
                      />
                    </svg>
                  </span>
                  <p>
                    Oops! you do not have any Phonebook <br />
                    at the moment.
                  </p>
                </tr>
              ) : isLoadingTable ? (
                <ScaleLoader />
              ) : (
                phonebooks &&
                phonebooks.data.data.map((phonebook, index) => (
                  <tr
                    key={index}
                    className={style["table--body"]}
                    // onClick={() => toggling(phonebook?.id)}
                  >
                    <td>{index + 1}.</td>
                    <td>{phonebook.name}</td>
                    <td>{phonebook.total}</td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => toggling(phonebook?.id)}
                    >
                      <div style={{ cursor: "pointer" }}>
                        <svg
                          width="16"
                          height="4"
                          viewBox="0 0 16 4"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4C1.46957 4 0.960859 3.78929 0.585786 3.41421C0.210714 3.03914 0 2.53043 0 2C0 1.46957 0.210714 0.96086 0.585786 0.585787C0.960859 0.210714 1.46957 0 2 0C2.53043 0 3.03914 0.210714 3.41421 0.585787C3.78929 0.96086 4 1.46957 4 2ZM10 2C10 2.53043 9.78929 3.03914 9.41421 3.41421C9.03914 3.78929 8.53043 4 8 4C7.46957 4 6.96086 3.78929 6.58579 3.41421C6.21071 3.03914 6 2.53043 6 2C6 1.46957 6.21071 0.96086 6.58579 0.585787C6.96086 0.210714 7.46957 0 8 0C8.53043 0 9.03914 0.210714 9.41421 0.585787C9.78929 0.96086 10 1.46957 10 2ZM14 4C14.5304 4 15.0391 3.78929 15.4142 3.41421C15.7893 3.03914 16 2.53043 16 2C16 1.46957 15.7893 0.96086 15.4142 0.585787C15.0391 0.210714 14.5304 0 14 0C13.4696 0 12.9609 0.210714 12.5858 0.585787C12.2107 0.96086 12 1.46957 12 2C12 2.53043 12.2107 3.03914 12.5858 3.41421C12.9609 3.78929 13.4696 4 14 4Z"
                            fill="#9D9C9C"
                          />
                        </svg>
                        {isOpen && phonebook?.id === selectedPhonebook ? (
                          <ActionCard
                            handleEdit={() =>
                              handleEditPhonebook(
                                phonebook?.id,
                                phonebook?.name,
                                phonebook.total
                              )
                            }
                            handleView={() =>
                              handleViewPhonebook(phonebook?.id, phonebook.name)
                            }
                            handleDelete={() =>
                              handleDeleteDialog(phonebook?.id)
                            }
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className={style["pagination--container"]}>
          {notFound || !phonebooks ? (
            ""
          ) : (
            <Pagination
              numberOfPages={phonebooks?.data?.from}
              currentPage={phonebooks?.data?.current_page}
              nextPage={phonebooks?.data?.to}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Phonebook;
